exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading_box .loading_mask[data-v-0b5a9556]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:5000}.loading_box .loading_toast[data-v-0b5a9556]{position:fixed;top:50%;left:50%;width:110px;height:110px;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);border-radius:5px;background:rgba(0,0,0,.8);text-align:center;padding-top:25px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:18px;z-index:5001}.loading_box .loading_toast .loading_content[data-v-0b5a9556]{color:#fff;margin-top:15px;font-size:16px}", ""]);

// exports
